import tours from './modules/tours'

window.startTour = tours.start

$(() => {
  // Only show the tour if a user is signed in
  if (!window.Power) return

  // If a user has finished a tour, the state is stored in the localStorage and not in the database
  if ($('body').attr('welcome-tour') === 'true') {
    window.startTour('app', false)
  }

  up.on('keydown', function(event) {
    switch (event.which) {
      case 112: // F1
        let helpButton = $('.help-button:visible').get(0)
        if (helpButton && !up.layer.isOverlay()) {
          helpButton.click()
        }
        return false
      case 27: // ESC
        tours.endCurrentTour()
    }
  })
})

up.on('up:location:changed', tours.endCurrentTour)
